import React, { useState } from 'react';
import s from './SalonFilterPage.module.scss';

const Switcher: React.FC = () => {
    const [isChecked, setIsChecked] = useState(false);

    const handleToggle = () => {
        setIsChecked(!isChecked);
    };

    return (
        <div className={s.switcher}>
            <input
                type="checkbox"
                id="toggle"
                className={s.switcher__input}
                checked={isChecked}
                onChange={handleToggle}
            />
            <label htmlFor="toggle" className={s.switcher__label}></label>
            <span className={s.switcher__text}>Available now</span>
        </div>
    );
};

export default Switcher;
